export default function HeroSection() {
  const stats = [
    { label: '高清资源覆盖', value: '10万+' },
    { label: '每日更新', value: '实时同步' },
    { label: '安全下载', value: '官方认证' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-foreground-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20amber%20and%20deep%20charcoal%20gradient%20background%2C%20abstract%20film%20texture%20with%20soft%20lens%20flares%2C%20premium%20movie%20theater%20ambiance%20with%20subtle%20golden%20lighting%20accents%2C%20elegant%20dark%20aesthetic%20with%20rich%20texture%20and%20depth%2C%20cinematic%20letterbox%20proportions%20with%20dramatic%20contrast&width=1600&height=900&seq=hero-bg-91movie&orientation=landscape"
          alt="91精品影视Hero背景"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-screen-2xl px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium bg-primary-500/20 text-primary-300 border border-primary-500/30 mb-5">
              官方正版 · 安全下载 · 海量资源
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              91精品影视 — 专业高清影视看片平台
            </h1>

            <p className="text-base md:text-lg text-white/70 leading-relaxed mb-6 max-w-xl lg:max-w-none">
              随时随地，畅享高清影视盛宴
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed mb-8 max-w-lg lg:max-w-none">
              91精品影视汇聚海量高清影视资源，涵盖热门电影、电视剧、综艺、动漫等全品类内容。支持手机端APP下载安装，提供流畅稳定的看片体验。每日实时更新最新片源，官方正版认证，安全可靠。无论你是追剧达人还是电影爱好者，这里都是你的掌上私人影院。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-400 whitespace-nowrap">{s.value}</div>
                  <div className="text-xs text-white/50 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm whitespace-nowrap transition-all cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                立即下载APP
              </a>
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 hover:bg-white/20 text-white font-medium text-sm whitespace-nowrap transition-all cursor-pointer border border-white/20"
              >
                了解更多
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[560px] md:w-[320px] md:h-[640px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20floating%20in%20dark%20space%20displaying%20a%20premium%20video%20streaming%20app%20interface%20with%20movie%20poster%20thumbnails%20in%20a%20grid%20layout%2C%20dark%20theme%20UI%20with%20warm%20orange%20and%20amber%20accent%20colors%2C%20cinematic%20glow%20surrounding%20the%20device%2C%20elegant%20product%20photography%20with%20dramatic%20lighting%20and%20soft%20reflections%2C%20minimalist%20composition%20on%20deep%20charcoal%20background&width=640&height=1280&seq=hero-phone-91movie&orientation=portrait"
                alt="91精品影视APP手机端展示"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}